import { LoadablePaint, type LoadableType } from '@confluence/loadable';

export const StorageManagementPageLoader: LoadableType<{}> = LoadablePaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-StorageManagementPage" */ './StorageManagementPage.tsx'
			)
		).StorageManagementPage;
	},
});
